/*eslint-disable*/
import React, { useState } from "react";
import Body from "./Body";

const Liabilities = () => {
  const [donutChartData, setDonutChartData] = useState([
    {
      categories: "Creditcard bill",
      contribution: 40,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(20, 184, 166, 0.56)",
    },
    {
      categories: "Loan from IDFC",
      contribution: 73.3,
      appearanceCount: 22,
      totalAttendee: 30,
      positionColor: "rgba(59, 130, 246, 0.56)",
    },
    {
      categories: "Loan from gramin bank",
      contribution: 40,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(99, 102, 241, 0.56)",
    },
    {
      categories: "Software product",
      contribution: 40,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(236, 72, 153, 0.56)",
    },
    {
      categories: "Monthly interest",
      contribution: 20,
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(245, 158, 11, 0.56)",
    },
    {
      categories: "Others",
      contribution: 20,
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(250, 204, 21, 0.56)",
    },
  ]);

  const [lineChartData, setLineChartData] = useState([
    {
      name: "Jan",
      liabilities: 4000,
    },
    {
      name: "Feb",
      liabilities: 3000,
    },
    {
      name: "Mar",
      liabilities: 2000,
    },
    {
      name: "Apr",
      liabilities: 2780,
    },
    {
      name: "May",
      liabilities: 1890,
    },
    {
      name: "Jun",
      liabilities: 2390,
    },
    {
      name: "Jul",
      liabilities: 3490,
    },
    {
      name: "Aug",
      liabilities: 2000,
    },
    {
      name: "Sept",
      liabilities: 2780,
    },
    {
      name: "Oct",
      liabilities: 1890,
    },
    {
      name: "Nov",
      liabilities: 2390,
    },
    {
      name: "Dec",
      liabilities: 3490,
    },
  ]);

  const [shortTermLiabilities, setShortTermLiabilities] = useState([
    {
      id: 1,
      title: "Credit card bill",
      description: "3 month",
      duration: "Semester",
      rest: "2 months",
    },
    {
      id: 2,
      title: "Credit card bill",
      description: "Monthly",
      duration: "1 year",
      rest: "2 months",
    },
    {
      id: 3,
      title: "Credit card bill",
      description: "Monthly",
      duration: "5 years",
      rest: "36 months",
    },
    {
      id: 4,
      title: "Credit card bill",
      description: "Monthly",
      duration: "10 years",
      rest: "26 months",
    },
    {
      id: 5,
      title: "Credit card bill",
      description: "Monthly",
      duration: "10 years",
      rest: "96 months",
    },
  ]);

  const [longTermLiabilities, setLongTermLiabilities] = useState([
    {
      id: 1,
      title: "Credit card bill",
      description: "3 month",
      duration: "2 years",
      rest: "6 months",
    },
    {
      id: 2,
      title: "Credit card bill",
      description: "Monthly",
      duration: "15 years",
      rest: "2 months",
    },
    {
      id: 3,
      title: "Credit card bill",
      description: "Monthly",
      duration: "5 years",
      rest: "2 months",
    },
    {
      id: 4,
      title: "Credit card bill",
      description: "1 day",
      duration: "1 week",
      rest: "3 days",
    },
    {
      id: 5,
      title: "Credit card bill",
      description: "15 days",
      duration: "1 month",
      rest: "15 days",
    },
  ]);

  const [listOfLiabilities, setListOfLiabilities] = useState([
    {
      id: 1,
      title: "Credit card bill",
      processSlots: "Yearly",
      timeToPay: "22 Oct, 2025",
      value: "30,000",
    },
    {
      id: 2,
      title: "Credit card bill",
      processSlots: "Monthly",
      timeToPay: "15 Nov, 2025",
      value: "50,000",
    },
    {
      id: 3,
      title: "Credit card bill",
      processSlots: "Bi-Weekly",
      timeToPay: "01 Dec, 2025",
      value: "1,200,000",
    },
    {
      id: 4,
      title: "Credit card bill",
      processSlots: "Monthly",
      timeToPay: "10 Jan, 2026",
      value: "500,000",
    },
    {
      id: 5,
      title: "Credit card bill",
      processSlots: "Monthly",
      timeToPay: "10 Jan, 2026",
      value: "500,000",
    },
    {
      id: 6,
      title: "Credit card bill",
      processSlots: "Monthly",
      timeToPay: "10 Jan, 2026",
      value: "500,000",
    },
    {
      id: 7,
      title: "Credit card bill",
      processSlots: "Monthly",
      timeToPay: "10 Jan, 2026",
      value: "500,000",
    },
  ]);
  const [addLiabilitiesModal, setAddLiabilitiesModal] = useState(false);

  const _this = {
    donutChartData,
    lineChartData,
    shortTermLiabilities,
    longTermLiabilities,
    listOfLiabilities,
    addLiabilitiesModal,
    setAddLiabilitiesModal,
  };
  return <Body {..._this} />;
};

export default Liabilities;
